// lib
import { Injectable } from '@angular/core';

// elvispos
import { SAMService } from '../sam/sam.service';
import { SAMMessage } from '../sam/interfaces/sam-message';
import { BaseService } from 'ngx-elvis-ds';
import { GUIService } from '../gui/gui.service';

export interface MenuItem {
  bl_active?: boolean;
  n0_company_id?: number;
  n0_item_id?: number;
  n0_kitchen_id?: number;
  n0_logo_id?: number;
  n0_price_from_barcode_price?: number;
  n0_sequence?: number;
  n0_store_id?: number;
  sz_background?: string;
  sz_color?: string;
  sz_image?: string;
  sz_item_code?: string;
  sz_short_descr?: string;
  n0_sell_by_qty?: number;
}

export interface Menu {
  n0_id?: number;
  n0_cnt?: number;
  sz_descr?: string;
  sz_icon?: string;
  itemsArray?: MenuItem[];
  current?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MenusService extends BaseService {

  menus: Array<Menu> = [];

  /**
   * Get ActiveMenu from List
   *
   * @readonly
   * @type {Menu}
   * @memberof MenusService
   */
  get activeMenu(): Menu {
    return this.menus.find((menu: Menu) => {
      return menu.current === true;
    });
  }

  constructor(
    public sam: SAMService,
  ) {
    super();
  }

  /**
   * Set current ActiveMenu
   *
   * @param {*} desiredMenu
   * @memberof MenusService
   */
  onSetActiveMenu(desiredMenu) {
    for (const m of this.menus) {
      if (!m.itemsArray) {
        m.itemsArray = [];
      }

      if (m.n0_id === desiredMenu.n0_id) {
        m.current = true;
      } else {
        m.current = false;
      }
    }
  }

  subscribeListeners() {
    // Reset ActiveMenu to first element in List after Clean
    this.sam.channels.gui.subscribe((msg: SAMMessage) => {
      if (['CLEAN'].includes(msg.Command)) {
        for (const menu of this.menus) {
          menu.current = false;
        }

        if (this.menus.length > 0) {
          if (!this.menus[0].itemsArray) {
            this.menus[0].itemsArray = [];
          }

          this.menus[0].current = true;
        }
      }
    });

    // Set Menus List
    this.sam.channels.menus.subscribe((msg: SAMMessage) => {
      if (['SET_MENU'].includes(msg.Command)) {
        const data = msg.parms;
        this.menus = data.restaurantMenu.filter(m => m != null);

        if (this.menus.length > 0) {
          if (!this.menus[0].itemsArray) {
            this.menus[0].itemsArray = [];
          }

          this.menus[0].current = true;
        }
      }
    });
  }
}
